export default __webpack_public_path__ + "7e0acbb0816ef6fad7c8d5a2501314ed.svg";